// extracted by mini-css-extract-plugin
export default {"floatButton":"_6851a54dc5","floatButtonCard":"dc9617b1a1"};